import styles from './styles.module.scss'

const StickyNavigation = (): JSX.Element => (
  <nav className={`${styles.stickyCta}`}>
    <a href="#form" className={`${styles.button} ${styles.primaryButton}`}>
      紹介者登録をする
    </a>
    <a href="#map" className={`${styles.button} ${styles.ghostButton}`}>
      不足エリアを見る
    </a>
  </nav>
)

export default StickyNavigation
